const $contactDateTrigger = $("#contact-date-trigger");
const $calendarCollapse = $("#calendar-collapse");

module.exports = {
    initCalendar: function () {
        // check if the #contactDateTrigger element exists on the page
        if ($contactDateTrigger.length === 0) {
            return;
        }

        // get the language from the data attribute
        const calendarLang = $contactDateTrigger.attr("data-calendar-language");

        // Initialize the calendar with the desired options
        $contactDateTrigger.bsCalendar({
            locale: calendarLang,
            url:null, // save as data-bs-target
            width:"100%",
            icons: {
                prev:"arrow-icon arrow-prev",
                next:"arrow-icon arrow-next",
                eventEdit:"",
                eventRemove:""
            },
            classes: {
                table: "table tables-sm table-borderless m-0 dates-table",
                tableHeaderCell: "day-name",
                tableHeaderCellActive: "day-name-active",
                tableTitleCell: "d-flex flex-nowrap justify-content-between align-items-center px-2 py-4",
                tableData: {
                    all: "rounded-circle",
                    today: "cell-today",
                    hover: "opacity-75",
                    active: "cell-active",
                    inMonth: "cell-in-month",
                    notInMonth: "cell-not-in-month",
                    eventCounter: "d-none"
                }
            },
            showTodayHeader:false,
            showEventEditButton:false,
            showEventRemoveButton:false,
            showPopover:false,
            popoverConfig: false,
            showEventContainer: false,
            showYearInHeader: false
        });
    },
    initCalendarCollaps: function () {
        $contactDateTrigger.on("click", ".js-cell-inner", function () {
            // set the date in the input field
            $("#contact-date").val($(this).parent().data("date"));

            // close the calendar
            $calendarCollapse.collapse("hide");
        });
    },
    collapseCalendarOnoutSideClick: function () {
        /**
        * Handles click events on the document to manage the visibility of a calendar collapse element.
        *
        * This function listens for click events on the entire document. It determines whether the click
        * occurred inside the calendar collapse element or on a button that toggles the collapse state.
        * If the click is outside the calendar collapse and not on a toggle button, the calendar collapse
        * element is hidden.
        *
        * @param {jQuery.Event} event - The click event triggered on the document.
        * @property {jQuery} $target - The jQuery object representing the element that was clicked.
        * @property {boolean} isClickInside - Indicates if the click was inside the calendar collapse element.
        * @property {boolean} isButtonClick - Indicates if the click was on a button that toggles the collapse.
        */
        $(document).click(function (event) {
            const $target = $(event.target);
            const isClickInside = $calendarCollapse.is($target) || $calendarCollapse.has($target).length !== 0;
            const isButtonClick = $target.is("[data-bs-toggle=\"collapse\"]");

            if (!isClickInside && !isButtonClick) {
                $calendarCollapse.collapse("hide");
            }
        });
    },
    digitValidation: function () {
        /**
        * Attaches an input event listener to the element with the ID 'contact-people'.
        * This listener ensures that only numeric input is allowed by replacing any non-digit
        * characters with an empty string as the user types.
        */
        $("#contact-people").on("input", function () {
            const $this = $(this);
            // Replace any non-digit character with an empty string
            $this.val($this.val().replace(/\D/g, ""));
        });
    },
    updateTopicOnPopulate: function () {
        /**
        * Event handler for the "topicDropdownChanged" event on the contact us form.
        * This function updates the select element within the form to the first non-empty option
        * and refreshes the Select2 plugin to reflect the change.
        *
        * @event
        * @listens topicDropdownChanged
        * @param {jQuery.Event} event - The event object associated with the "topicDropdownChanged" event.
        * @this {jQuery} - The jQuery object representing the contact us form.
        */
        $(".contact-us__form").on("topicDropdownChanged", function () {
            // Find the select element and set its value
            var $selectElement = $(this).find("select.contact-us-topic");

            // Set the value to the first non-empty option
            $selectElement.find("option").each(function () {
                const $this = $(this);

                if ($this.val() !== "") {
                    $selectElement.val($this.val());
                    return false; // Break the loop after setting the first non-empty value
                }

                return true;
            });

            // Refresh the Select2 plugin
            $selectElement.trigger("change.select2");
        });
    }
};
